<template>
	<article class="itv-form-success">
		<div class="itv-form-success__wrapper">
			<div v-if="image" class="itv-form-success__img">
				<img
					:src="image"
					alt="Форма успешно отправлена"
					title="Форма успешно отправлена"
					width="80"
					height="82"
				/>
			</div>
			<div class="itv-form-success__title">
				{{ title }}
			</div>
			<div class="itv-form-success__desc">
				{{ text }}
			</div>
		</div>
		<div class="itv-form-success__btn">
			<primary-button :content="button" @click-event="$emit('hideModal')" />
		</div>
	</article>
</template>

<script>
import PrimaryButton from './PrimaryButton'

export default {
	name: 'FormSuccess',
	components: {
		PrimaryButton,
	},
	props: {
		image: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: 'Спасибо за обращение!',
		},
		text: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			button: {
				btnColorType: 'green',
				text: 'Хорошо',
			},
		}
	},
}
</script>
